import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHeart, FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';
import './LandingNavbar.css';

const LandingNavbar = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme, isDark } = useTheme();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleHome = () => {
    navigate('/welcome');
  };

  return (
    <nav className="landing-navbar">
      <div className="navbar-container">
        <div className="navbar-logo" onClick={handleHome}>
          <FaHeart className="logo-icon" />
          <span className="logo-text">CHATOO</span>
        </div>
        
        <div className="navbar-actions">
          <button 
            className="theme-toggle" 
            onClick={toggleTheme}
            aria-label={isDark ? 'Passer au mode clair' : 'Passer au mode sombre'}
          >
            {isDark ? <FaSun /> : <FaMoon />}
          </button>
          
          <button className="login-button" onClick={handleLogin}>
            <span>Se connecter</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;
